import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundDoubleFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M9.998 3.599c.65 0 1.325.043 1.992.145C11.823.943 8.91 0 5.999 0 2.999 0 0 1 0 3.999 0 5.881 1.18 6.976 2.801 7.53c.383-1.306 1.275-2.26 2.393-2.88C6.61 3.863 8.38 3.599 9.998 3.599"
                        fill="currentColor"
                    />
                    <path
                        d="M3.999 8.998c0 2.832 2.675 3.881 5.499 3.99v3.008c.46-.383 1.042-.795 1.67-1.24 2.153-1.523 4.828-3.415 4.828-5.758 0-3-3-4-5.998-4-3 0-5.999 1-5.999 4"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundDoubleFilledSize16Glyph.displayName = 'BubbleRoundDoubleFilledSize16Glyph';
